module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/tier-1-a9cbad1bf1a794b917fa870b90069c8f.svg";